'use strict';

angular.module('mandaeApp')
	.filter('qrcodes', function() {
		return function (encomenda) {
			var qrCodes = '';
		  	for (var i in encomenda.qrCodes) {
		  		qrCodes += encomenda.qrCodes[i] + ' ';
		  	}

		  	return qrCodes;
		};

	});